import React, {createContext, useContext} from 'react';
import PropTypes from 'prop-types';
import {makeStyles} from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';
import Shipped from './Shipped';
import InReceiving from './InReceiving';
import Received from '../received/ReceivingClosed';
import {Backdrop, Button, CircularProgress, Stack, Toolbar} from '@mui/material';
import {firestore} from '../../config/firebaseConfig';
import useToggle from './../../shared/functions/useToggle';
import ResumeReceivingRepport from './ResumeReceivingRepport';
import {useDispatch} from 'react-redux';
import {archiveReceiving} from "../../redux/slices/receiving";
import ReceivingArchived from "../received/ReceivingArchived";

const ReceivingProvider = createContext({
    setSeletectRepport: (ids) => {
    },
    setReceivings: (receiving) => {
    }
});


export const useReceivingContext = () => {
    return useContext(ReceivingProvider);
}

function TabPanel(props) {
    const {children, value, index, ...other} = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    {children}
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        backgroundColor: 'transparent',
    },
}));


export default function ReceivingTab() {
    const dispatch = useDispatch()
    const classes = useStyles();
    const [value, setValue] = React.useState(0);
    const {open, handleOpen, handleClose} = useToggle();
    const [checkedId, setChecked] = React.useState([]);
    const [receiving, setReceivings] = React.useState([]);
    const [receivingGroup, setReceivingsGroup] = React.useState([]);
    const [allShipings, setAllShippings] = React.useState([]);
    const [loading, setLoading] = React.useState(false);


    const handleClosing = () => {
        setReceivingsGroup([])
        setAllShippings([])
        setChecked([])
        handleClose()
    }
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const setSeletectRepport = (Ids) => {
        setChecked(Ids);
    }

    const getShippingDetails = async () => {
        setLoading(true)
        await Promise.all(receiving.map(async (res) => {
            const {ShippingId} = res[0];
            // console.log(ShippingId);
            const response = await firestore.collection("shipping_orders").doc(ShippingId).collection('Shippings_c').get();

            setAllShippings((sh) => {
                const res = response.docs.map((doc) => {
                    return {id: doc.id, ...doc.data()};
                });
                return [...sh, ...res]
            });
        }));


        let rev = [];

        receiving.forEach((rc) => {
            rev.push(...rc);
        });

        setReceivingsGroup((rv) => [...rv, ...rev]);
        setLoading(false)
        handleOpen();
    }


    const selectedReceiving = (rc) => {
        // console.log(rc)
        const exist = receiving.find(r => r[0]?.ContainerCode === rc[0]?.ContainerCode);
        if (!exist) {
            return setReceivings((r) => [...r, rc]);
        }
        setReceivings((r) => r.filter((_r) => _r[0].ContainerCode !== rc[0].ContainerCode));
    }


    const handleArchive = () => {
        setLoading(true)

        dispatch(archiveReceiving(receiving, () => {
            setLoading(false)
        }))

    }


    return (
        <div className={classes.root}>
            {
                loading && (
                    <Backdrop sx={{zIndex: (theme) => theme.zIndex.drawer + 2}} open={loading}>
                        <CircularProgress size={100}/>
                    </Backdrop>
                )
            }

            <ReceivingProvider.Provider value={{setSeletectRepport, selectedReceiving, Ids: checkedId}}>
                <AppBar position="static">
                    <Toolbar sx={{justifyContent: 'space-between'}}>
                        <Tabs value={value} onChange={handleChange} aria-label="simple tabs example">
                            <Tab label="Shipped" {...a11yProps(0)} />
                            <Tab label="In Receiving" {...a11yProps(1)} />
                            <Tab label="RECEIVED CLOSED" {...a11yProps(2)} />
                            <Tab label="Archived" {...a11yProps(3)} />
                        </Tabs>

                        {
                            checkedId.length > 0 && (
                                <Stack direction={'row'} spacing={2}>
                                    {
                                        value !== 3 && (
                                            <Button size="small" variant="contained" color={'error'} onClick={handleArchive}>
                                                Archiver
                                            </Button>
                                        )
                                    }

                                    <Button size="small" variant="contained" onClick={getShippingDetails}>
                                        Rapport
                                    </Button>
                                </Stack>
                            )
                        }


                    </Toolbar>
                </AppBar>
                <TabPanel value={value} index={0}>
                    <Shipped/>
                </TabPanel>
                <TabPanel value={value} index={1}>
                    <InReceiving/>
                </TabPanel>
                <TabPanel value={value} index={2}>
                    <Received/>
                </TabPanel>
                <TabPanel value={value} index={3}>
                    <ReceivingArchived/>
                </TabPanel>

                {open && <ResumeReceivingRepport Shps={allShipings} Revs={receivingGroup} handleClose={handleClosing}/>}
            </ReceivingProvider.Provider>
        </div>
    );
}
